import { computed } from "vue";
import useCreateComponentConfig, { EStates } from "../../../composables/useCreateComponentConfig.js";
import focus from "../../constants/focus.js";
import { SIZES } from "@/ui/ts/types/Sizes";
var EAccordionElements = /* @__PURE__ */ ((EAccordionElements2) => {
  EAccordionElements2["ITEM"] = "ITEM";
  EAccordionElements2["TRIGGER"] = "TRIGGER";
  EAccordionElements2["CONTENT"] = "CONTENT";
  return EAccordionElements2;
})(EAccordionElements || {});
export default function useAccordionConfig(props) {
  const { itemClasses } = useItemConfig(props);
  const { triggerClasses } = useTriggerConfig(props);
  const { contentClasses } = useContentConfig(props);
  return {
    itemClasses,
    triggerClasses,
    contentClasses
  };
}
function useItemConfig(props) {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    "ITEM" /* ITEM */,
    /* tw */
    `focus-within:none`
  );
  const itemClasses = computed(
    () => getClasses("ITEM" /* ITEM */, void 0, props.size, props.state || EStates.DEFAULT)
  );
  return {
    itemClasses: itemClasses.value
  };
}
function useTriggerConfig(props) {
  const { setBase, addBaseState, getClasses, addSize } = useCreateComponentConfig();
  setBase(
    "TRIGGER" /* TRIGGER */,
    /* tw */
    `text-comp-high-contrast gap-base flex flex-1 cursor-pointer items-center justify-between rounded-control transition-colors delay-0 duration-200 ease-linear ${focus}`
  );
  addBaseState(
    "TRIGGER" /* TRIGGER */,
    EStates.DISABLED,
    /* tw */
    `disabled:cursor-not-allowed`
  );
  addSize(
    "TRIGGER" /* TRIGGER */,
    SIZES.SMALL,
    /* tw */
    `py-base label-md disabled:py-base min-h-[56px]`
  );
  addSize(
    "TRIGGER" /* TRIGGER */,
    SIZES.MEDIUM,
    /* tw */
    `py-base label-lg disabled:py-sm min-h-[56px]`
  );
  addSize(
    "TRIGGER" /* TRIGGER */,
    SIZES.LARGE,
    /* tw */
    `py-base heading-xs disabled:py-base min-h-[64px]`
  );
  addBaseState(
    "TRIGGER" /* TRIGGER */,
    EStates.FOCUSED,
    /* tw */
    `${focus}`
  );
  const triggerClasses = computed(
    () => getClasses("TRIGGER" /* TRIGGER */, void 0, props.size, props.state || EStates.DEFAULT)
  );
  return {
    triggerClasses: triggerClasses.value
  };
}
function useContentConfig(props) {
  const { setBase, getClasses } = useCreateComponentConfig();
  setBase(
    "CONTENT" /* CONTENT */,
    /* tw */
    `text-neutral-primary paragraph-md pb-base transition-opacity duration-200 linear delay-200`
  );
  const contentClasses = computed(
    () => getClasses("CONTENT" /* CONTENT */, void 0, props.size, props.state || EStates.DEFAULT)
  );
  return {
    contentClasses: contentClasses.value
  };
}
